import {SVGProps} from "react";

const CheckIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    viewBox="0 0 20 20"
    fill="none"
    {...props}
  >
    <path d="M7.50045 13.4749L4.60878 10.5833C4.45297 10.4275 4.24164 10.3399 4.02128 10.3399C3.80092 10.3399 3.58959 10.4275 3.43378 10.5833C3.27797 10.7391 3.19043 10.9504 3.19043 11.1708C3.19043 11.2799 3.21192 11.3879 3.25367 11.4887C3.29543 11.5895 3.35663 11.6811 3.43378 11.7583L6.91711 15.2416C7.24211 15.5666 7.76711 15.5666 8.09211 15.2416L16.9088 6.42494C17.0646 6.26913 17.1521 6.0578 17.1521 5.83744C17.1521 5.61709 17.0646 5.40576 16.9088 5.24994C16.753 5.09413 16.5416 5.00659 16.3213 5.00659C16.1009 5.00659 15.8896 5.09413 15.7338 5.24994L7.50045 13.4749Z" fill="currentColor"/>
  </svg>
)

export default CheckIcon;
